<div class="draggable-box-container"
     [ngStyle]="{'top': options.panelY + 'px', 'left': options.panelX + 'px'}"
     cdkDragBoundary=".content-box" cdkDrag>
  <div class="details-header" cdkDragHandle>
    <p>{{options.panelTitle}}</p>
    <div class="fal fa-times close-btn" (click)="closePanel()"></div>
  </div>
  <div class="details-body">
    <ng-content></ng-content>
  </div>
</div>

